module.exports = __webpack_public_path__ + "img/cartonorder.d88d6b85.jpeg";